import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BACKEND_URL, PRODUCT } from '../environments/environment';
import { take } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
    providedIn: 'root'
})
export class AccountPINService {
    private http = inject(HttpClient);

    serviceUrl = `${BACKEND_URL}/migration/send_temporary_pin`;

  	getPin(mdn: string): Promise<any> {
		const headers = new HttpHeaders({
			'transaction-id': uuidv4()
		});

		return new Promise<any>((resolve, reject) => {
			this.http.post<any>(`${this.serviceUrl}`, {product: PRODUCT , mdn}, { headers })
				.pipe(take(1))
				.subscribe({
					next: (result) => resolve(result),
					error: (error) => reject(error)
				});
		});
	}
}